if (!customElements.get('video-sequence')) {
  customElements.define(
    'video-sequence',
    class VideoSequence extends HTMLElement {
      connectedCallback() {
        this.clips = Array.from(this.querySelectorAll('.video-sequence__clip'));
        if (this.clips.length === 0) return;

        this.index = 0;

        this.clips.forEach((video) => {
          // Browsers only allow autoplay when muted + inline.
          video.muted = true;
          video.playsInline = true;
          video.loop = false;
          video.addEventListener('ended', () => this.next());
        });

        // Size the frame to the first clip's real ratio (avoids letterbox/crop).
        const first = this.clips[0];
        const applyRatio = () => {
          if (first.videoWidth && first.videoHeight) {
            this.style.setProperty('--seq-ratio', `${first.videoWidth} / ${first.videoHeight}`);
          }
        };
        if (first.readyState >= 1) applyRatio();
        else first.addEventListener('loadedmetadata', applyRatio, { once: true });

        this.playCurrent();
      }

      playCurrent() {
        const video = this.clips[this.index];
        if (!video) return;

        // Warm up the next clip so the hand-off is seamless.
        const nextIndex = (this.index + 1) % this.clips.length;
        const nextVideo = this.clips[nextIndex];
        if (nextVideo && nextVideo !== video) nextVideo.preload = 'auto';

        this.clips.forEach((clip) => clip.classList.toggle('is-active', clip === video));

        const played = video.play();
        if (played && typeof played.catch === 'function') {
          // Autoplay may be blocked (e.g. reduced-data mode); fail quietly.
          played.catch(() => {});
        }
      }

      next() {
        const current = this.clips[this.index];
        if (current) {
          current.pause();
          current.currentTime = 0;
        }
        // Loop the whole set once the last clip finishes.
        this.index = (this.index + 1) % this.clips.length;
        this.playCurrent();
      }
    }
  );
}
